// Keep the preview beside its control when a complete card fits. Stacked
// layouts use the vertical space without covering the control itself.
export function resourcePreviewPosition(rect, { width, height, topInset = 12 }, cardWidth = 380, ratio = 1.6) {
  const edge = 12, gap = 14, footer = 50;
  const w = Math.min(cardWidth, width - edge * 2);
  const naturalHeight = (w - 16) / ratio + footer + 8;
  const clamp = (value, min, max) => Math.max(min, Math.min(value, Math.max(min, max)));
  const spaces = { left: rect.left - edge - gap, right: width - rect.right - edge - gap,
    above: rect.top - topInset - gap, below: height - rect.bottom - edge - gap };
  const side = spaces.left >= w ? 'left' : spaces.right >= w ? 'right'
    : spaces.above >= naturalHeight || spaces.above >= spaces.below ? 'above' : 'below';
  const availableHeight = side === 'above' || side === 'below' ? spaces[side] : height - topInset - edge;
  const h = Math.min(naturalHeight, Math.max(0, availableHeight));
  if (h < 120 || w < 160) return null;
  const left = side === 'left' ? rect.left - w - gap : side === 'right' ? rect.right + gap
    : clamp(rect.left + rect.width / 2 - w / 2, edge, width - edge - w);
  const top = side === 'above' ? rect.top - h - gap : side === 'below' ? rect.bottom + gap
    : clamp(rect.bottom - h, topInset, height - edge - h);
  const origin = side === 'left' ? `right ${clamp(rect.top + rect.height / 2 - top, 0, h)}px`
    : side === 'right' ? `left ${clamp(rect.top + rect.height / 2 - top, 0, h)}px`
      : `${clamp(rect.left + rect.width / 2 - left, 0, w)}px ${side === 'above' ? 'bottom' : 'top'}`;
  return { side, left, top, width: w, height: h, origin };
}
